module.exports = __webpack_public_path__ + "img/cr.1927f94f.jpg";